import { Capacitor } from "@capacitor/core";
import { getAnalytics } from "firebase/analytics";
import { initializeApp, FirebaseApp } from "firebase/app";
import { getMessaging, Messaging } from "firebase/messaging";

export interface IFirebaseReturn {
  messaging: Messaging | undefined;
  firebaseApp: FirebaseApp | undefined;
}

const useFirebase = (): IFirebaseReturn => {
  const firebaseConfig = {
    apiKey: process.env.REACT_APP_API_KEY,
    authDomain: process.env.REACT_APP_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_PROJECT_ID,
    storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_APP_ID,
    measurementId: process.env.REACT_APP_MEASUREMENT_ID
  };

  // Initialize Firebase
  const firebaseApp: FirebaseApp = initializeApp(firebaseConfig);
  getAnalytics(firebaseApp);

  let messaging: Messaging | undefined = undefined;

  // Only try to get messaging if we're in a web environment
  if (typeof window !== "undefined" && Capacitor.getPlatform() === "web") {
    // Check if the browser supports the necessary APIs for messaging
    if ("serviceWorker" in navigator && "PushManager" in window) {
      try {
        messaging = getMessaging(firebaseApp);
      } catch (error) {
        // console.error("Firebase Messaging initialization failed:", error);
      }
    } else {
      // console.warn("This browser doesn't support the required APIs for Firebase Messaging.");
    }
  } else {
    // console.log("Firebase Messaging is skipped on non-web platforms (e.g., iOS WebView).");
  }

  return { messaging, firebaseApp };
};

export default useFirebase;
